<template>
	<header class="app-header">
		<div class="wrap">
			<h1>
				<a href="/">MTG Deck Builder</a>
				<small class="by-iristorm">
					by Iristorm Design
					<!-- by
					<a
						href="https://iristormdesign.com/"
						target="_blank"
						@click="gtagEvent('header_Iristorm_Design_click', {})"
					>
						Iristorm Design<svg>
							<use href="#open-in-new-icon" />
						</svg>
					</a>
					<span>Iristorm Design</span>-->
				</small>
			</h1>
			<app-header-menu />
		</div>
	</header>
</template>

<script setup>
// import { event as gtagEvent } from 'vue-gtag'
import AppHeaderMenu from '@/components/AppHeaderMenu.vue'
</script>

<style lang="scss">
@use '@/sass/app-header.scss';
</style>
